module.exports = __webpack_public_path__ + "img/del.f35acaa8.svg";